<template>
  <div class="inquiry_warp">
    <van-overlay :show="inquiryShow">
      <div class="focus_main">
        <div class="focus_pop">
          <div class="inquiry_title">APPOINT</div>
          <div class="focut_content">
            <div class="group-type">
              <span
                :class="activeIndex == ind ? 'activeNames' : ''"
                :key="ind"
                @click="activeIndex = ind ; activeType = mode"
                v-for="(mode,ind) in type"
              >{{mode}}</span>
            </div>

            <van-field
              :autosize=" { maxHeight:'2rem', minHeight:'2rem'}"
              class="text_area"
              fixed="true"
              maxlength="1000"
              name="text"
              placeholder="Please add a brief description"
              placeholder-class="placeholder"
              show-word-limit
              type="textarea"
              v-model="content"
            />
          </div>
          <div class="submit_btn">
            <span @click="resetForm">Cancel</span>
            <span @click="submit">Submit</span>
          </div>
        </div>
        <!-- <div class="focus_pop_finish" v-else>
            您的预约参观信息已经发送成功
            后续动态请在个人中心预约中查询
        </div>-->
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "order",
  components: {
  },
  data () {
    return {
      content: '',
      inquiryShow: false,
      exInfo: {},
      type: ['Meet', 'Purchase', 'Representative', 'Others'],
      activeIndex: -1,
      activeType: '',
      isOrder: true,
      editModel: false,
      editMsg: '',
      isLoading:false,
    }
  },
  computed: {
    ...mapGetters({
      exhibitorId: 'company/getExhibitorId',
      companyId: 'company/getCompanyId',
      userInfo: 'getUserInfo',
      exhibitionId: 'getExhibitionId'
    }),
  },
  methods: {
    //提交 完成后返回上一页  
    ...mapActions({
      addEnquiry: 'company/addEnquiry',
      addOrder: 'company/addOrder',
      editTopice: 'my/editTopice',
      LinkToMyOrder: "linkTo/LinkToMyOrder",     //预约洽谈
      getUserAdvisorySetting:"getUserAdvisorySetting"
    }),
    open (info = null) {
      this.isOrder = true;
      this.inquiryShow = true;
      if (info) {
        this.editModel = true;
        this.editMsg = info;
        this.type.forEach((e, i) => {
          if (e == info.type) {
            this.activeIndex = i;
            this.activeType = e;
          }
        });
        this.content = info.content;
      }
    },
    async submit () {
      if(this.isLoading){
        return 
      }
      if (!this.activeType) {
        this.$toast("Please select a type！");
        return;
      }
      if (!this.content) {
        this.$toast("Please add a brief description！");
        return;
      }
      this.isLoading=true;
      if (this.editModel) { // 编辑模式
        let body = {
          id: this.editMsg.id,
          opt: {
            type: this.activeType,
            content: this.content,
          }
        }
        let result = await this.editTopice(body);
        this.isLoading=false;
        if (result.result) {
          this.myDialog();
          this.editMsg = '';
          this.editModel = false;
          this.$toast.success('edit succeeded');
          this.resetForm();
          this.$emit('finish')
        } else {
          this.$toast.fail(result.message || 'failed to send');
        }
      } else { // 新增模式
        let body = {
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          memberId: this.userInfo.id,
          type: this.activeType,
          content: this.content,
          langVersion: 'en'
        }
        let result = await this.addOrder(body);
        this.isLoading=false;
        this.getUserAdvisorySetting()
        if (result.result) {
          //   this.$toast.success('发送成功');
          // this.isOrder = false;
          this.myDialog();
          this.resetForm();
        } else {
          this.$toast.fail(result.message || 'failed to send');
        }
      }
    },
    resetForm () {
      this.content = "";
      this.inquiryShow = false;
    },
    myDialog () {
      this.$dialog.confirm({
        message: 'The message has been sent successfully',
        className: 'reg_dialog',
        confirmButtonText: 'View records',
        cancelButtonText: "cancel",
      }).then(() => {
        console.log(1111111111)
        this.LinkToMyOrder();
      }).catch(() => { });
    },
  }
};
</script>


<style lang="scss" scoped>
.inquiry_warp {
  z-index: 3001;
  position: relative;
  .focus_main {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .focus_pop {
    width: 6.2rem;
    height: 6.2rem;
    padding: 0.35rem 0.3rem 0;
    background: #fff;
    border-radius: 0.15rem;
    position: relative;
    .inquiry_title {
      font-size: 0.3rem;
      text-align: center;
      color: #333;
      line-height: 1.2;
      margin-bottom: 0.4rem;
      letter-spacing: 1px;
      padding-left: 1px;
      font-weight: 600;
    }
    .submit_btn {
      height: 0.9rem;
      width: 100%;
      display: flex;
      align-items: center;
      position: absolute;
      border-top: 1px solid #d2d3d5;
      left: 0;
      right: 0;
      bottom: 0;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0.89rem;
        border: none;
        border-radius: 0;
        color: #333;
        font-size: 0.3rem;
        width: 100%;
        &:first-child {
          border-right: 1px solid #d2d3d5;
        }
        &:last-child {
          color: #1890ff;
        }
      }
    }
    .focut_content {
      .input_read {
        background: #eee;
        color: #666;
        padding: 0 0.2rem;
        display: flex;
        justify-content: space-between;
        height: 0.7rem;
        margin-bottom: 0.2rem;
        align-items: center;
        // line-height: 0.7rem;
        p {
          font-size: 0.26rem;
          width: 30%;
        }
        ::v-deep .van-field {
          padding: 0;
          background: transparent;
          line-height: inherit;
          .van-field__word-limit {
            margin-top: 0;
            font-size: 0.24rem;
          }
          input {
            // width: 70%;
            color: #666;
            outline: none;
            border: none;
            background: transparent;

            text-align: right;
            // padding: 0.15rem 0;
            font-size: 0.26rem;
            box-sizing: border-box;
            // height: 35px;
          }
          input[type="tel"] {
            color: #666;
            background: #eee;
          }
        }
      }
      .placeholder {
        font-size: 0.26rem;
      }
      ::v-deep .text_area {
        border: 1px solid #eee;
        height: 2rem;
        padding: 0.1rem 0.2rem;
        box-sizing: border-box;
        width: 100%;
        font-size: 0.26rem;
        line-height: 0.38rem;
        color: #333;
        .van-field__body {
          .van-field__control {
            min-height: 1.5rem;
            font-size: 0.26rem;
            line-height: 0.38rem;
            &::-webkit-input-placeholder {
              color: #bfbfbf;
              font-size: 0.26rem;
            }
            &:-moz-placeholder {
              color: #bfbfbf;
              font-size: 0.26rem;
            }
            &::-moz-placeholder {
              color: #bfbfbf;
              font-size: 0.26rem;
            }
            &:-ms-input-placeholder {
              color: #bfbfbf;
              font-size: 0.26rem;
            }
          }
        }
        .van-field__word-limit {
          font-size: 0.24rem;
          margin-top: -0.05rem;
        }
      }
    }
  }
}
.group-type {
  margin-bottom: 0.2rem;
  span {
    font-size: 0.26rem;
    color: #666;
    display: inline-block;
    border: solid 1px #ccc;
    border-radius: 0.1rem;
    padding: 0.13rem 0.13rem;
    margin-right: 0.2rem;
    min-width: 2.7rem;
    margin-bottom: 0.2rem;
    text-align: center;
    &:nth-child(1) {
      margin-right: 0.2rem;
      width: 2.7rem;
    }
    &:nth-child(2) {
      width: 2.7rem;
      margin-right: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  span:last-child {
    margin-right: 0;
  }
  .activeNames {
    background-color: #1890ff;
    border-color: #1890ff;
    color: #fff;
  }
}
.focus_pop_finish {
  width: 5.6rem;
  padding: 0.6rem 1rem;
  background: #fff;
  border-radius: 0.15rem;
  text-align: center;
  font-size: 0.24rem;
  line-height: 1.5;
  color: #333;
}
</style>

